import { render, staticRenderFns } from "./finance-icon.vue?vue&type=template&id=4cef36a9&functional=true&"
import script from "./finance-icon.vue?vue&type=script&lang=js&"
export * from "./finance-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports